import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Modal, Input, InputNumber, Select, Button, message, Image } from 'antd';
import MainContext from '@/stores/stores';
import listApi from '@/api/listApi';
import accountApi from '@/api/accountApi';
import ObsImageUpload from '@/components/ObsImageUpload';
import styles from '../../index.module.scss';

interface PurchaseAsstModalProps {
  open: boolean;
  info: any;
  onCancel: () => void;
}

const PurchaseAsstModal: React.FC<PurchaseAsstModalProps> = (props) => {
  const { open = false, info = {}, onCancel } = props;
  const { commonStore, setCommonStore } = useContext(MainContext);
  const { colorPrimary } = commonStore;
  const intl = useIntl();
  const navigate = useNavigate();
  const [value, setValue] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (info && open) {
      setValue({
        ...info,
        purchase_day: info.purchase_day ? info.purchase_day : intl.formatMessage({ id: '无' }),
        remark: info.remark ? info.remark : '',
        images: Array.isArray(info.images) ? info.images : (info.images ? String(info.images).split(',').filter(Boolean) : [])
      });
    }
  }, [info, open, intl]);

  const valueChange = (val: any, type: string) => {
    let _value = JSON.parse(JSON.stringify(value));
    _value[type] = val;
    setValue(_value);
  };

  const toSubmit = () => {
    let images = Array.isArray(value.images) ? value.images : [];
    setLoading(true);
    listApi.submitPurchaseAsst({
      ...value,
      images,
    }).then((res: any) => {
      if (res.code === 1) {
        message.success(intl.formatMessage({ id: '操作成功！' }));
        getExquireNum();
        onCancel && onCancel();
        navigate(`/mine/requirementList`);
      }
      setLoading(false);
    }).catch((err: any) => {
      setLoading(false);
    });
  };

  const getExquireNum = () => {
    accountApi.getRequireList({
      page: 1,
      size: 10,
      keyword: ''
    }).then((res: any) => {
      if (res.code === 1) {
        let total = res.data && res.data.total ? res.data.total : 0;
        setCommonStore({
          type: 'requireNum',
          value: total
        });
      }
    });
  };

  const toDemand = () => {
    navigate(`/mine/requirementList`);
    onCancel && onCancel();
  };

  const delImage = (index: number) => {
    let images = Array.isArray(value.images) ? [...value.images] : [];
    images.splice(index, 1);
    valueChange(images, 'images');
  };

  return (
    <Modal
      open={open}
      title={intl.formatMessage({ id: '采购助手' })}
      width={450}
      footer={null}
      onCancel={onCancel}
    >
      <div className={styles['asst-wrap']}>
        <div className={styles['asst-pop']}>{intl.formatMessage({ id: 'Hi～尊敬的【{name}】我是采购小助手，为您匹配优质货源，您可以点击一键获取专属服务～' }, { name: commonStore.userInfo && commonStore.userInfo.repair_shop_name ? commonStore.userInfo.repair_shop_name : (commonStore.userInfo && commonStore.userInfo.phone ? commonStore.userInfo.phone : '') })}</div>
        <div className={styles['item']}>
          <span className={styles['title']}>
            <i>*</i>
            {intl.formatMessage({ id: '商品名称' })}
          </span>
          <Input style={{ width: 180 }} value={value.part_name} onChange={e => valueChange(e.target.value, 'part_name')} />
        </div>
        <div className={styles['item']}>
          <span className={styles['title']}>
            <i>*</i>
            {intl.formatMessage({ id: 'OE号' })}
          </span>
          <Input style={{ width: 180 }} value={value.oe} onChange={e => valueChange(e.target.value, 'oe')} />
        </div>
        <div className={styles['item']}>
          <span className={styles['title']}>
            <i></i>
            {intl.formatMessage({ id: '数量' })}
          </span>
          <InputNumber min={1} step={1} style={{ width: 180 }} value={value.amount} onChange={val => valueChange(val, 'amount')} />
        </div>
        <div className={styles['item']}>
          <span className={styles['title']}>
            <i></i>
            {intl.formatMessage({ id: '期望到货时间' })}
          </span>
          <Select
            style={{ width: 180 }}
            options={[{
              label: intl.formatMessage({ id: '无' }),
              value: intl.formatMessage({ id: '无' })
            }, {
              label: intl.formatMessage({ id: '7天' }),
              value: intl.formatMessage({ id: '7天' })
            }, {
              label: intl.formatMessage({ id: '15天' }),
              value: intl.formatMessage({ id: '15天' })
            }, {
              label: intl.formatMessage({ id: '30天' }),
              value: intl.formatMessage({ id: '30天' })
            }, {
              label: intl.formatMessage({ id: '90天' }),
              value: intl.formatMessage({ id: '90天' })
            }]}
            value={value.purchase_day}
            onChange={val => valueChange(val, 'purchase_day')}
          />
        </div>
        <div className={styles['item']}>
          <span className={styles['title']}>
            <i></i>
            {intl.formatMessage({ id: '备注' })}
          </span>
          <Input style={{ width: 180 }} placeholder={intl.formatMessage({ id: '备注' })} value={value.remark} onChange={e => valueChange(e.target.value, 'remark')} />
        </div>
        <div className={styles['item'] + ' ' + styles['upload-item']}>
          <span className={styles['title']}>
            <i></i>
            {intl.formatMessage({ id: '图片' })}
          </span>
          <div className={styles['asst-upload-wrap']}>
            <ObsImageUpload
              value={Array.isArray(value.images) ? value.images : []}
              onChange={(images: string[]) => valueChange(images, 'images')}
            />
            {
              Array.isArray(value.images) && value.images.length ? (
                <div className={styles['asst-img-list']}>
                  <Image.PreviewGroup>
                    {
                      value.images.map((item: string, index: number) => {
                        return (
                          <div className={styles['asst-img-item']} key={item + index}>
                            <Image src={item} alt="" width={72} height={62} style={{ objectFit: 'cover' }} preview={{ src: item }} />
                            <i className="iconfont icon-quxiao1" onClick={(e) => { e.stopPropagation(); delImage(index); }} />
                          </div>
                        );
                      })
                    }
                  </Image.PreviewGroup>
                </div>
              ) : null
            }
          </div>
        </div>
        <div className="mt30">
          <Button style={{ width: '100%' }} icon={<i className='icon iconfont icon-tianjiaxuqiu' />} type="primary" size="large" loading={loading} onClick={toSubmit}>{intl.formatMessage({ id: '加需求' })}</Button>
        </div>
        <div className='pt10 pb10 center pointer' style={{ color: colorPrimary }} onClick={toDemand}>
          {intl.formatMessage({ id: '查看历史采购需求' })}
        </div>
      </div>
    </Modal>
  );
};

export default PurchaseAsstModal;
